































































import { defineComponent, ref } from '@vue/composition-api';
import useStore from '../my/store';
import { TaskTypeEnum, missionInfo, PAGE_BACK_FLOW_MY } from '../config';
import Box from './Box.vue';
import openOrDownload from '@/utils/openOrDownload';
import { getQueryParams } from '@/utils/util';

export default defineComponent({
    name: 'mission',
    components: {
        Box,
    },
    setup() {

        const store = useStore();

        const list = ref([]);

        const { uuid = '' } = getQueryParams();

        const goToApp = () => {
            const url = `${window.location.origin}${PAGE_BACK_FLOW_MY}${uuid ? `&uuid=${uuid}` : ''}`;
            openOrDownload(url);
        };

        return {
            store,
            list,
            TaskTypeEnum,
            missionInfo,
            goToApp,
        };
    },
});
